module.exports = __webpack_public_path__ + "img/home-header-img.25b32151.png";